export default __webpack_public_path__ + "static/page-preview-e60be0f04494f439616a69d7c7a0b4ae.jpg";